
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","viewBox":"0 0 14 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.8906 0.0193475C2.3028 0.145941 1.07163 1.40326 0.740285 1.93073C-1.08819 4.83912 0.811903 8.27557 2.74736 10.6018C4.56246 12.7833 7.3713 15.3877 10.4598 14.9518C11.6193 14.788 12.3162 14.3423 13.1625 13.5788C13.5328 13.2445 14.0094 12.9378 13.9854 12.3735C13.9637 11.86 13.5468 11.4594 13.205 11.1198C8.53976 6.48305 9.9837 14.1681 5.66258 9.58995C5.03793 8.92816 4.33662 8.09133 3.93247 7.2756C3.14319 5.68278 4.08224 5.42632 4.87092 4.72233C5.31222 4.32858 5.59423 4.02934 5.56511 3.39072C5.54223 2.88464 5.25903 2.35123 4.99871 1.92657C4.58951 1.25795 3.83232 -0.183321 2.8906 0.0193475Z","fill":"#B8B8B8"}})])
          )
        }
      }
    